import React from 'react'

import { ReactComponent as TivityLogo } from 'src/media/images/tivity-logo-white.svg'
import { ReactComponent as WalmartLogo } from 'src/media/images/client-logos/walmart-spark.svg'
import { ReactComponent as FywLogo } from 'src/media/images/client-logos/fitness-your-way.svg'
import { ReactComponent as WellOntargetLogo } from 'src/media/images/client-logos/well-on-target.svg'
import { ReactComponent as PrimeLogo } from 'src/media/images/client-logos/prime-white.svg'

export const clientConfig = {
  walmart: {
    colors: {
      brandColor: '#041E42',
      brandTextColor: '#FFFFFF',
      primaryActionColor: '#0071DC',
      primaryActionHoverColor: '#006ACE',
      tertiaryColor: '#F3BE41',
    },
    logo: <WalmartLogo />,
    burnAlong: false,
    lesMills: false,
  },
  tivity: {
    colors: {
      brandColor: '#041E42',
      primaryActionColor: '#041E42',
      primaryActionHoverColor: '#0E3E80',
      textColor: '#313233',
      tertiaryColor: '#F3BE41',
    },
    logo: <TivityLogo />,
    burnAlong: false,
    lesMills: false,
  },
  fyw: {
    colors: {
      brandColor: '#ffffff',
      brandTextColor: '#313233',
      primaryActionColor: '#FE382E',
      primaryActionHoverColor: '#D22C24',
      textColor: '#313233',
      tertiaryColor: '#FE382E',
      headerTextColor: '#0e2675',
    },
    logo: <FywLogo />,
    burnAlong: {
      isPaid: false,
      url: 'DigitalContent/BurnAlong',
      description:
        'Your membership comes with Burnalong. Access thousands of online classes by clicking below to sign in or register your Burnalong membership today.',
    },
    lesMill: false,
  },
  hcsc: {
    colors: {
      brandColor: '#ffffff',
      brandTextColor: '#333333',
      primaryActionColor: '#006dc6',
      primaryActionHoverColor: '#005da8',
      textColor: '#333333',
      tertiaryColor: '#0078bf',
      headerTextColor: '#333333',
    },
    logo: <WellOntargetLogo />,
    burnAlong: {
      isPaid: false,
      url: 'api/platform/v1/partner/burnalong/forward',
      description:
        'Your subscription comes with access to Burnalong. Register your account to get instant access to thousands of online classes through the website or mobile app today!',
    },
    lesMills: {
      url: 'lesmills',
    },
  },
  prime: {
    colors: {
      brandColor: '#AF292E',
      brandTextColor: '#ffffff',
      primaryActionColor: '#AF292E',
      primaryActionHoverColor: '#7A2426',
      textColor: '#2a2a2a',
      tertiaryColor: '#ffffff',
    },
    logo: <PrimeLogo />,
    burnAlong: false,
    lesMills: false,
  },
}

export const allowedClients = Object.keys(clientConfig)

// IMPORTANT: Make sure this syncs up with CSP in web.config
export const allowedHostnames = new RegExp(
  // eslint-disable-next-line prettier/prettier, no-useless-escape
  'localhost|classesdev.develop|([^%]*)tivityhealth.com|([^%]*)walmart.com|([^%]*).tivity.health|([^%]*).tv.ty|([^%]*)bcbsilforyourhealth.com|([^%]*).primemember.com'
)
